import { ref } from 'vue';

// What the server says about itself before anyone is signed in. One thing so far: whether people
// may create accounts and workspaces by themselves, or staff create them (docs/requirements.md §19 #49).

/** `false` until the server says otherwise: a page must never offer a door that turns out to be shut. */
export const signUpOpen = ref(false);

let loaded: Promise<void> | undefined;

/** Asks once per page load. A failure leaves the closed default in place and is asked again next time. */
export function loadConfig(): Promise<void> {
  loaded ??= fetch('/api/config', { headers: { accept: 'application/json' } })
    .then(async (response) => {
      if (!response.ok) throw new Error('config unavailable');
      const body: unknown = await response.json();
      signUpOpen.value = typeof body === 'object' && body !== null && Reflect.get(body, 'signUp') === 'open';
    })
    .catch(() => {
      loaded = undefined;
    });
  return loaded;
}
